import React from 'react';

const Card = ({ 
  children, 
  className = '',
  hoverable = true,
  ...props 
}) => {
  const baseStyles = 'border-2 border-border bg-background p-8 md:p-12 rounded-none transition-all duration-300';
  const hoverStyles = hoverable 
    ? 'group cursor-pointer hover:bg-accent hover:border-accent' 
    : '';
  
  return (
    <div
      className={`${baseStyles} ${hoverStyles} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;

